import {useSuspenseQuery} from '@tanstack/react-query';
import {getQueryKey} from '@shared/queryKeyMap';
import {parseDateWithFormat} from '@shared/dateUtils';
import {diApi} from '@di-shared/api/di';

export enum EngineOilLifeStatus {
  GOOD,
  NORMAL,
  WARNING,
  BAD,
}

const EngineOilLifeStatusBoundary = {
  NORMAL: 6,
  BAD: 0,
};

function getEngineOilLifeStatus(finalLife: number, avgLife: number) {
  if (finalLife > avgLife) {
    return EngineOilLifeStatus.GOOD;
  }
  if (finalLife > EngineOilLifeStatusBoundary.NORMAL) {
    return EngineOilLifeStatus.NORMAL;
  }
  if (finalLife === EngineOilLifeStatusBoundary.BAD) {
    return EngineOilLifeStatus.BAD;
  }
  return EngineOilLifeStatus.WARNING;
}

function useSestDetailEngineOilAndFilterAdvanced(vin: string) {
  const {data} = useSuspenseQuery({
    queryKey: [getQueryKey(diApi.engineController.getEngine), vin],
    queryFn: () =>
      diApi.engineController.getEngine({
        vin,
      }),
    select: (data) => data.data,
  });

  /**
   * 평균이상: GOOD
   * 6% 이상 ~ 평균 : NORMAL
   * 0% 초과 ~ 6% 미만 : WARNING
   * 0% : BAD
   */
  const engineOilLifeStatus = getEngineOilLifeStatus(data.finalLife, data.avgLife);
  return {
    ...data,
    engineOilLifeStatus,
    updateDate: parseDateWithFormat(data.updateDate),
    avgLife: data.avgLife,
    finalLife: data.finalLife,
  };
}

export default useSestDetailEngineOilAndFilterAdvanced;
